import { render } from "./TaskModal.vue?vue&type=template&id=44b68400&scoped=true"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import "./TaskModal.vue?vue&type=style&index=0&id=44b68400&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b68400"]])

export default __exports__